import React, { useState, useEffect, useRef } from 'react';
import { PuffLoader } from 'react-spinners';
import { Button, Container } from '@mui/material';
import axios from 'axios';
import { MDBDataTable } from 'mdbreact';
import { baseURL } from '../base_url';
import { RiFileExcel2Fill } from "react-icons/ri";
import { read, utils, writeFile } from 'xlsx';

const Ford = () => {
    const [loading, setLoading] = useState(false);
    const [fetchFleet, setFetchFleet] = useState([]);
    const [activeCount, setActiveCount] =useState(0);
    const [inActiveCount, setInActiveCount] =useState(0);
    const [exportTableData, setExportTableData] = useState([]);

    const handleExportTableData = () => {
        const headings = [['S.No','VIN Nimber','Location Name','Make','Model','Status']];
        const sampleVin = exportTableData;
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, sampleVin, { origin: 'A2', skipHeader: true });
        utils.book_append_sheet(wb, ws, 'Ford Fleet List');
        writeFile(wb, 'Ford Fleet List.xlsx');
      }
    useEffect(() => {
        setLoading(true);
        axios.get(baseURL + "/get_ford_fleet_status").then((res) => {
            var j = 1;
            var active = 0
            var in_active = 0
            if(res.data.length > 0){
                let rowsData = [];
                let ExportTableData = [];
                const myDataSet = res.data;
                for (var index = 0; index < res.data.length; index++) {
                    let rowItem = {};
                    const val = myDataSet[index];
                    rowItem["id"] = j;
                    rowItem["vin"] = val.vin_number;
                    rowItem["location"] = val.loc_name;
                    rowItem["make"] = val.make;
                    rowItem['model'] = val.model;
                    rowItem['status'] = val.ford_status;
                    rowsData.push(rowItem)
                    ExportTableData.push([j, val.vin_number,val.loc_name,val.make, val.model, val.ford_status])
                    if(val.ford_status == 'active'){
                        active++;
                    }else{
                        in_active++;
                    }
                    j++;
                }
                setExportTableData(ExportTableData)
                setActiveCount(active);
                setInActiveCount(in_active);
                setFetchFleet(rowsData);
            }else{
                setFetchFleet([]);
            }
            setLoading(false);
        });
    },[]);
    const data = {
        columns: [
            {
            label: 'S.No',
            field: 'id',
            },
            {
            label: 'VIN',
            field: 'vin',
            },
            {
            label: 'Location Name',
            field: 'location',
            },
            {
            label: 'Make',
            field: 'make',
            },
            {
            label: 'Model',
            field: 'model',
            },
            {
            label: 'Status',
            field: 'status',
            }
        ],
        rows: fetchFleet
    };
    return(
        <div className='body_class'>
            {loading ? (
                <div className="loader-overlay">
                    <div className="loader">
                    <PuffLoader color="#00308F" loading={true} size={200} />
                    </div>
                </div>
            ) : ("")}
            <div className='container-fluid'>
            <div className="">
                <h4>Ford Fleet Info</h4>
            </div>
            <div className='row'>
                <div className='col-auto'><h5>Total: {activeCount+inActiveCount}</h5></div>
                <div className='col-auto'><h5>Active: {activeCount}</h5></div>
                <div className='col-auto'><h5>In Active: {inActiveCount}</h5></div>
            </div>
            <div className="row mt-1">
                <div className="col-md-12">
                    <Button size="small" className="" style={{marginBottom:"-3.5rem"}} variant="contained" onClick={handleExportTableData}>
                        <RiFileExcel2Fill size={16}/>&nbsp;Export
                    </Button>
                    <MDBDataTable
                        bordered
                        data={data}
                        large={false}
                        displayEntries={false}
                        search="true"
                        noBottomColumns={true}
                        className="pagination-right-aligned"
                        searching={true}
                    />
                </div>
            </div>
            </div>
        </div>
    )
}

export default Ford